
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supporters",
      function () {
        return require("private-next-pages/supporters.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supporters"])
      });
    }
  